import { Directive, ElementRef, inject } from '@angular/core';

@Directive({
  selector: '[fgbLazyLoadItem]'
})
export class LazyLoadItemDirective {
  private _el: ElementRef<HTMLDivElement> = inject(ElementRef);

  get el(): ElementRef<HTMLDivElement> {
    return this._el;
  }


}
